import { z } from "zod";

export interface ProductionGrainListEntity {
  id: number;
  nombre: string;
  aplicaPPMB: boolean;
  sumaHA: boolean;
  granoAdmis: number;
  granoAdmisDesc: string
}

export interface ProductionGrainsListResponse {
  listado: ProductionGrainListEntity[];
  totalRecords: number;
  totalPages: number;
  page: number;
  pageSize: number;
}

export const productionGrainsFilterSchema = z.object({
  Nombre: z.string().optional(),
  AplicaPPMB: z.any().optional(),
  SumaHA: z.any().optional(),
  GranosAdmis: z.string().optional(),
});
